// extracted by mini-css-extract-plugin
export default {"main":"_1c67d6b060","tit":"b3bbbf35c7","maintitle":"f0d5c69d25","ylw":"_4831d7c6ab","white":"eea389e026","mv_title":"cfb38e64d1","mv_nc":"_3ea1395f28","mv_in":"_63caeaaf2c"};